const DEFAULT_HEADER_HEIGHT = 75;

export const scrollToId = (id: string, position?: 'start' | 'center' | 'end' | 'nearest') => {
    if (id) {
        const el = document.getElementById(id);
        el?.scrollIntoView({ block: position || 'center', behavior: 'smooth' });
    }
};

export const scrollToIdWithMargin = (
    id: string,
    options?: { margin?: number; parentId?: string }
) => {
    const el = document.getElementById(id);

    if (el) {
        const parentEl = options?.parentId && document.getElementById(options.parentId);
        const isParentScrollable = parentEl && parentEl.scrollHeight > parentEl.clientHeight;
        const container = (isParentScrollable && parentEl) || window;

        if (container) {
            const y =
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                typeof container.scrollY !== 'undefined'
                    ? el.getBoundingClientRect().top + (container as Window).scrollY
                    : el.offsetTop;

            container?.scrollTo({
                top: y - (options?.margin || DEFAULT_HEADER_HEIGHT),
                behavior: 'smooth',
            });
        }
    }
};

export const scrollToTop = () =>
    typeof window !== 'undefined' && window.scrollTo({ top: 0, behavior: 'smooth' });
